import(/* webpackMode: "eager" */ "/app/src/app/network-dao/apply/page.jsx")